import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import {fetchFavorites} from "../../catalog/infrastructure/CatalogService";
import {useComercialContext} from "../../../comercial/ComercialContext";

export const FavoriteProducts = () => {
  const { actingAsCliente } = useComercialContext();
  const fetchFn = () => fetchFavorites(actingAsCliente?.numCliente ?? null);
  return (
    <ProductSwiper title={'TUS FAVORITOS'} fetchFn={fetchFn} />
  );
};
